import { CouponDiscountCurrency, CouponDiscountType } from './'

export interface CouponTemplateContentView {
  title: string
  description: string
}

export enum CouponTemplateStatus {
  ISSUED = 'ISSUED',
  REVOKED = 'REVOKED',
  SUSPENDED = 'SUSPENDED',
  EXPIRED = 'EXPIRED',
}

export interface CouponTemplateDiscountView {
  couponDiscountType: CouponDiscountType
  discountAmount: number
  maxDiscountAmount: number
  currency: CouponDiscountCurrency
}

export interface CouponTemplateLimitView {
  perPersonCount: number
  totalCount: number | null
}

export interface CouponTemplateView {
  id: string
  status: CouponTemplateStatus
  content: CouponTemplateContentView
  discount: CouponTemplateDiscountView
  limit: CouponTemplateLimitView
  minimumPaymentAmount: number
  startIssuanceDatetimeUtc: string
  endIssuanceDatetimeUtc: string
  endExpiryPeriod: number
  endExpiryDatetimeUtc: string
  creator: string
}

export interface PageViewCouponTemplateView {
  contents: CouponTemplateView[]
  totalContentsCount: number
}

export interface RevokeCouponRequest {
  userId: number
  revokedBy: number
  couponId: string
}

export interface CouponTemplatePolicyView {
  type: 'DISTRICT_POLICY' | 'CONCERN_BODY_PART_POLICY'
  policy: string
}

export interface CouponTemplatePoliciesView {
  couponTemplateId: string
  couponTemplatePolicies: CouponTemplatePolicyView[]
}

export interface DistrictCountView {
  code: string
  name: string
  hospitalCount: number
}

export interface DistrictHospitalCountsView {
  counts: {
    city: DistrictCountView
    districts: DistrictCountView[]
  }[]
}

export interface CreateCouponTemplateRequest {
  id: string
  title: string
  description: string
  discountType: CouponDiscountType
  discountAmount: number
  maxDiscountAmount: number
  currency: CouponDiscountCurrency
  perPersonCount: number | null
  totalCount: number | null
  minimumPaymentAmount: number
  startIssuanceDatetimeUtc: string
  endIssuanceDatetimeUtc: string
  endExpiryPeriod: number
  endExpiryDatetimeUtc: string | null
  creator: string
}

export enum CouponTemplatePolicyType {
  DISTRICT_POLICY = 'DISTRICT_POLICY',
  CONCERN_BODY_PART_POLICY = 'CONCERN_BODY_PART_POLICY',
}

export interface CouponTemplatePolicyRequest {
  type: CouponTemplatePolicyType
  policy: string
}
